<header
  *transloco="let t"
  class="flex min-h-(--size-app-header) px-4 md:px-6 bg-surface text-text-primary border-b border-border-default"
>
  <div class="mx-auto flex w-full max-w-7xl flex-wrap items-stretch gap-x-4 nav:flex-nowrap">
    <div class="flex h-app-header-inner shrink-0 items-center gap-2">
      <span class="flex size-6 shrink-0 items-center justify-center rounded-full bg-accent-01 text-label font-semibold text-accent-07">
        <app-brand-mark class="size-4" />
      </span>
      <span class="text-heading-md">{{ t('nav.appTitle') }}</span>
    </div>

    <ng-template #navSlot>
      @if (size() === 'computer') {
        @if (showLinks()) {
          <nav class="top-nav" [attr.aria-label]="t('nav.main')">
            @if (showGettingStarted()) {
              <a class="nav-item" routerLink="/start" routerLinkActive="nav-item--active" ariaCurrentWhenActive="page">
                <fa-icon [icon]="gettingStartedIcon" class="option-row__icon size-4 leading-none" aria-hidden="true" />
                {{ t('nav.gettingStarted') }}
                <app-badge color="info" [label]="t('nav.gettingStartedCount', { done: onboarding.doneOfTotal(), total: onboardingTotal })" />
              </a>
            }
            @for (item of dailyItems; track item.id) {
              <a class="nav-item" [routerLink]="item.route" routerLinkActive="nav-item--active" ariaCurrentWhenActive="page">
                <fa-icon [icon]="item.icon" class="option-row__icon size-4 leading-none" aria-hidden="true" />
                {{ t(item.labelKey) }}
              </a>
            }
            <span class="mx-2 h-6 w-px flex-none self-center bg-border-default" aria-hidden="true"></span>
            @for (item of setUpItems(); track item.id) {
              <a class="nav-item" [routerLink]="item.route" routerLinkActive="nav-item--active" ariaCurrentWhenActive="page">
                <fa-icon [icon]="item.icon" class="option-row__icon size-4 leading-none" aria-hidden="true" />
                {{ t(item.labelKey) }}
              </a>
            }
          </nav>
        } @else {
          <div class="top-nav" aria-hidden="true"><span class="nav-item"></span></div>
        }
      }
    </ng-template>

    <ng-template #accountSlot>
      @if (ready()) {
        <app-top-bar-account />
      }
    </ng-template>

    @if (navOnOneRow()) {
      <ng-container [ngTemplateOutlet]="navSlot" />
      <ng-container [ngTemplateOutlet]="accountSlot" />
    } @else {
      <ng-container [ngTemplateOutlet]="accountSlot" />
      <ng-container [ngTemplateOutlet]="navSlot" />
    }
  </div>
</header>
